import { render, staticRenderFns } from "./PartnerBox.vue?vue&type=template&id=580eab93&scoped=true&"
import script from "./PartnerBox.vue?vue&type=script&lang=js&"
export * from "./PartnerBox.vue?vue&type=script&lang=js&"
import style0 from "./PartnerBox.vue?vue&type=style&index=0&id=580eab93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580eab93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580eab93')) {
      api.createRecord('580eab93', component.options)
    } else {
      api.reload('580eab93', component.options)
    }
    module.hot.accept("./PartnerBox.vue?vue&type=template&id=580eab93&scoped=true&", function () {
      api.rerender('580eab93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/integrations/PartnerBox.vue"
export default component.exports